





























































































































import {Location} from 'vue-router';

import {loginService} from '../services/login.service';
import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {User} from '@/models';

const Auth = namespace('Auth');

@Component
export default class LoginHeader extends Vue {
  @Auth.Getter
  public loginUser!: User;

  @Auth.Getter
  public isLoggedIn!: boolean;

  @Auth.Action
  public signOut!: () => void;

  logOut() {
    this.signOut();
    this.$router.push('/');
  }
}
